import axios from 'axios'

const api = async (method, url, payload, isDownload = false, getUploadProgress = false) => {
	const uploadProgress = {
		onUploadProgress: function (progressEvent) {
			var uploadStatus = (progressEvent.loaded / progressEvent.total) * 100

			let params

			if (typeof payload.id === 'number') {
				params = {
					percentage: Math.round(uploadStatus),
					id: payload.id
				}
			} else {
				params = Math.round(uploadStatus)
			}

			if (getUploadProgress) payload.commit('uploadProgress', params)
		}

	}

	try {
		let response

		if (method === 'get') {
			response = await axios.get(url)
		} else if (method === 'post') {
			if (isDownload) {
				response = await axios.post(url, payload, { responseType: 'blob' }, uploadProgress)
			} else {
				response = await axios.post(url, payload, uploadProgress)
			}
		}

		const { data } = response

		if (data) {
			const result = {
				status: true,
				data: data
			}

			return result
		}

		return false
	} catch ({ response }) {
		try {
			const { data } = response

			if (data) {
				const result = {
					status: false,
					data: data
				}

				return result
			}
		} catch (e) { }
	}
}

export default api
